export const environment = {
  production: false,
  url: '',
  urlLocal: '',
  baseUrl: 'https://api.test.wegestu.com',
  baseUrlGalery: 'https://api.test.wegestu.com/api/User/file/gallery_users/',
  baseUrlGaleryy: 'https://api.test.wegestu.com/api/Company/file/gallery_company/',
  baseUrlGaleryCv: 'https://api.test.wegestu.com/api/User/file/gallery_cvs/',
  stripeKey:
    'pk_test_51OlbLsEOYgTbI3nHfgProbrHAo4fGVuiHqN8fqLbXly7vwpE8TlsrGF3ISMUAe7zUxKRivHhVuG1laUXS90LiTqf00MO75r2Mq',
  cgu_link: "https://wegestu.com/conditions-generales-de-lutilisation-entreprises/",
   cgv_link:"https://wegestu.com/conditions-generales-de-services-cgv/",
  confidential_policy_link: "https://wegestu.com/politique-de-confidentialite/",
  mention_legal_link: "https://wegestu.com/mentions-legales/",
  baseUrlGaleryCompany:'https://api.test.wegestu.com/api/Company/file/gallery_company/',
};
